var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper note-wrapper"},[_c('div',{staticClass:"wrapper-header row"},[_c('div',{staticClass:"ticker-info"}),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"remove item"},[_c('i',{staticClass:"material-icons",on:{"click":_vm.removeTile}},[_vm._v(" clear ")])])])]),_c('div',{staticClass:"card-content full-width row no-wrap justify-center items-stretch content-stretch"},[_c('q-list',{staticClass:"card-editor full-height full-width justify-center",attrs:{"no-border":""}},[_c('q-editor',{staticClass:"editor full-height",style:({ background: 'white' }),attrs:{"dense":_vm.$q.screen.lt.md,"toolbar":[
					['bold', 'link', 'fullscreen', 'quote', 'unordered'],
					[
						{
							label: '',
							icon: _vm.$q.iconSet.editor.fontSize,
							fixedLabel: true,
							fixedIcon: true,
							list: 'no-icons',
							options: ['size-1', 'size-2', 'size-3', 'size-4'],
						} ] ],"fonts":{
					arial: 'Arial',
					arial_black: 'Arial Black',
					comic_sans: 'Comic Sans MS',
					courier_new: 'Courier New',
					impact: 'Impact',
					lucida_grande: 'Lucida Grande',
					times_new_roman: 'Times New Roman',
					verdana: 'Verdana',
				}},model:{value:(_vm.editor),callback:function ($$v) {_vm.editor=$$v},expression:"editor"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }